import Modal from "@ts-digital/vrc/es/components/modal";
import { isEmpty } from "lodash";
import { useState } from "react";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../CustomButton";
import { TextArea } from "../TextArea";
import "./style.css";

const fm = getFormattedMessageWithScope("components.AlreadyPaidModal");

interface AlreadyPaidModalProps {
    onAbort: Function;
    onConfirm: Function;
    visible: boolean;
    loading: boolean;
}

export const AlreadyPaidModal = ({
    onAbort,
    onConfirm,
    visible,
    loading,
}: AlreadyPaidModalProps) => {
    const [note, setNote] = useState<string>("");

    function onSetNote(e: any) {
        setNote(e.target.value);
    }

    function onAbortModal() {
        setNote("");
        onAbort();
    }

    function onConfirmModal() {
        onConfirm(isEmpty(note) ? undefined : note);
    }

    return (
        <Modal
            className="c-AlreadyPaidModal"
            visible={visible}
            title={
                <span className="c-AlreadyPaidModal-title">{fm("title")}</span>
            }
            onClose={onAbort}
            footer={
                <div className="c-AlreadyPaidModal-footer">
                    <div className="c-AlreadyPaidModal-footer-buttons">
                        <CustomButton
                            kind="secondary"
                            colorScheme="ghost"
                            className="c-AlreadyPaidModal-footer-buttons-abort"
                            onClick={onAbortModal}
                            disabled={loading}
                        >
                            {fm("abort")}
                        </CustomButton>
                        <CustomButton
                            kind="primary"
                            onClick={onConfirmModal}
                            loading={loading}
                        >
                            {fm("confirm")}
                        </CustomButton>
                    </div>
                </div>
            }
        >
            <div className="c-AlreadyPaidModal-content">
                {fm("line1")}
                <p className="c-AlreadyPaidModal-content-secondLine">
                    {fm("line2")}
                </p>
                <TextArea
                    label={fm("noteForCreditor")}
                    value={note}
                    onChange={onSetNote}
                    maxLength={250}
                    rows={5}
                    className="c-AlreadyPaidModal-content-note-textarea"
                />
            </div>
        </Modal>
    );
};
